<app-shared-featured [departmentType]="departmentType"></app-shared-featured>
<app-shared-best-movement
    *ngIf="setupService.layout?.components?.latestMovementsRanking == '1'"
    [departmentType]="departmentType"
></app-shared-best-movement>
<app-shared-match-program
    *ngIf="setupService.layout?.components?.programCentral == '1'"
    [departmentType]="departmentType"
></app-shared-match-program>
<!-----------Home e Paginação-------->
<app-shared-latest-news [departmentType]="departmentType"></app-shared-latest-news>
<app-shared-latest-videos [departmentType]="departmentType"></app-shared-latest-videos>
<!--
	TODO:
	perPage: enviar o `limit` q retorna da api para o componente saber quantas paginas vão ser no total (size / perPage)
	size: quantidade total de noticias. não pode ser `registers.length` pois acho que o array registers já virá limitado a 10
 -->
<!-- <app-shared-pagination
    [perPage]="5"
    [size]="100"
    (onChange)="onPageChange($event)"
></app-shared-pagination> -->
